import { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const OneTimeReportsIcon = ({
  width = '144',
  height = '146'
}: Omit<IconSvgProps, 'children'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 144 146"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="72.1768" cy="70.9062" r="70" fill="#F9F9F9" />
      <path
        d="M101.579 99.0156L99.7726 99.0156L57.7681 99.0156C56.1858 99.0156 54.9031 97.7329 54.9031 96.1506L54.9031 42.5666C54.9031 40.9844 56.1858 39.7017 57.7681 39.7017L67.2462 39.7017L101.579 39.7017C103.236 39.7017 104.579 41.0448 104.579 42.7017L104.579 96.0156C104.579 97.6725 103.236 99.0156 101.579 99.0156Z"
        fill="white"
        stroke="#7E7E7E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.9492 108.262H91.7744C93.4313 108.262 94.7744 106.919 94.7744 105.262V60.0009C94.7744 59.7357 94.6691 59.4813 94.4815 59.2938L84.5461 49.3583C84.3586 49.1708 84.1042 49.0654 83.839 49.0654H69.3757H50.8142C49.2319 49.0654 47.9492 50.3481 47.9492 51.9304V73.0985V105.262C47.9492 106.919 49.2924 108.262 50.9492 108.262Z"
        fill="white"
        stroke="#7E7E7E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54.3525 102.023V88.0234H59.2772V102.023H54.3525Z"
        fill="#7E7E7E"
        stroke="#7E7E7E"
        strokeWidth="2.72"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M64.0518 102.023V82.0234H68.9764V102.023H64.0518Z"
        fill="#7E7E7E"
        stroke="#7E7E7E"
        strokeWidth="2.72"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M73.751 102.023V75.0234H78.6757V102.023H73.751Z"
        fill="#7E7E7E"
        stroke="#7E7E7E"
        strokeWidth="2.72"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M83.4502 102.023V67.0234H88.3749V102.023H83.4502Z"
        fill="#7E7E7E"
        stroke="#7E7E7E"
        strokeWidth="2.72"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M92.8877 44.3008L98.6056 44.3008C99.1578 44.3008 99.6056 44.7485 99.6056 45.3008L99.6056 50.9084"
        stroke="#7E7E7E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M86.5088 44.3008L88.6529 44.3008"
        stroke="#7E7E7E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <mask id="path-10-inside-1_2490_70107" fill="white">
        <path d="M65.3076 50.9092C65.3076 60.496 57.536 68.2676 47.9492 68.2676C38.3624 68.2676 30.5908 60.496 30.5908 50.9092C30.5908 41.3224 38.3624 33.5508 47.9492 33.5508C57.536 33.5508 65.3076 41.3224 65.3076 50.9092Z" />
      </mask>
      <path
        d="M65.3076 50.9092C65.3076 60.496 57.536 68.2676 47.9492 68.2676C38.3624 68.2676 30.5908 60.496 30.5908 50.9092C30.5908 41.3224 38.3624 33.5508 47.9492 33.5508C57.536 33.5508 65.3076 41.3224 65.3076 50.9092Z"
        fill="#31B59F"
      />
      <path
        d="M64.0879 50.9092C64.0879 59.8223 56.8624 67.0479 47.9492 67.0479V69.4873C58.2096 69.4873 66.5273 61.1696 66.5273 50.9092H64.0879ZM47.9492 67.0479C39.0361 67.0479 31.8105 59.8223 31.8105 50.9092H29.3711C29.3711 61.1696 37.6888 69.4873 47.9492 69.4873V67.0479ZM31.8105 50.9092C31.8105 41.996 39.0361 34.7705 47.9492 34.7705V32.3311C37.6888 32.3311 29.3711 40.6488 29.3711 50.9092H31.8105ZM47.9492 34.7705C56.8624 34.7705 64.0879 41.996 64.0879 50.9092H66.5273C66.5273 40.6488 58.2096 32.3311 47.9492 32.3311V34.7705Z"
        fill="#31B59F"
        mask="url(#path-10-inside-1_2490_70107)"
      />
      <path
        d="M47.5518 60.9724C46.3888 60.9724 45.2812 60.7785 44.2289 60.3909C43.1951 60.0032 42.3275 59.3386 41.626 58.3971L43.5643 56.708C43.9705 57.3356 44.5335 57.8341 45.2535 58.2033C45.9919 58.5725 46.758 58.7756 47.5518 58.8125V51.779C46.8319 51.5944 46.1396 51.3544 45.475 51.059C44.8104 50.7452 44.2197 50.3667 43.7028 49.9237C43.2044 49.4806 42.8075 48.9545 42.5121 48.3453C42.2167 47.7176 42.069 46.9884 42.069 46.1577C42.069 45.3824 42.2167 44.6716 42.5121 44.0255C42.8075 43.3794 43.2044 42.8256 43.7028 42.3641C44.2197 41.8841 44.8104 41.5056 45.475 41.2287C46.1396 40.9334 46.8319 40.758 47.5518 40.7026V38.875H48.881V40.7026C49.8779 40.7026 50.8563 40.8872 51.8162 41.2564C52.7947 41.6256 53.6069 42.1887 54.253 42.9456L52.4254 44.607C52.0009 44.0532 51.484 43.6286 50.8748 43.3332C50.2656 43.0194 49.601 42.8625 48.881 42.8625V49.7575C49.6194 49.9975 50.3394 50.256 51.0409 50.5329C51.7424 50.8098 52.3608 51.1606 52.8962 51.5851C53.45 51.9913 53.8838 52.4989 54.1977 53.1081C54.53 53.7174 54.6961 54.4742 54.6961 55.3788C54.6961 56.2095 54.5392 56.9572 54.2254 57.6218C53.9115 58.2864 53.4869 58.8586 52.9516 59.3386C52.4347 59.8186 51.8255 60.197 51.124 60.4739C50.4225 60.7509 49.6748 60.917 48.881 60.9724V62.9384H47.5518V60.9724ZM47.5518 42.8625C46.6473 43.0286 45.9181 43.4071 45.3643 43.9978C44.8289 44.5701 44.5612 45.2993 44.5612 46.1854C44.5612 46.6654 44.6351 47.0715 44.7827 47.4038C44.9489 47.7361 45.1612 48.0222 45.4196 48.2622C45.6965 48.5022 46.0104 48.7145 46.3611 48.8991C46.7303 49.0653 47.1272 49.2314 47.5518 49.3976V42.8625ZM48.881 58.8125C49.8225 58.7017 50.6071 58.3417 51.2347 57.7325C51.8809 57.1233 52.2039 56.3757 52.2039 55.4896C52.2039 54.9911 52.1116 54.5573 51.927 54.1881C51.7424 53.8189 51.4932 53.5051 51.1794 53.2466C50.8655 52.9882 50.5055 52.7759 50.0994 52.6097C49.7117 52.4251 49.3056 52.2682 48.881 52.139V58.8125Z"
        fill="white"
      />
      <path
        d="M111.915 121.588C112.488 120.491 114.058 120.49 114.631 121.587L118.002 128.043C118.074 128.181 118.187 128.294 118.326 128.367L124.784 131.74C125.881 132.313 125.88 133.882 124.783 134.455L118.326 137.824C118.187 137.897 118.074 138.01 118.002 138.149L114.631 144.607C114.058 145.704 112.488 145.704 111.915 144.606L108.55 138.149C108.477 138.01 108.364 137.897 108.225 137.824L101.764 134.455C100.666 133.883 100.666 132.312 101.763 131.739L108.225 128.367C108.364 128.294 108.477 128.181 108.55 128.042L111.915 121.588Z"
        fill="#CCCCCC"
      />
      <path
        d="M33.8045 2.2205C34.1373 1.5822 35.0506 1.58196 35.3839 2.22008L37.3446 5.97484C37.3867 6.0555 37.4525 6.12133 37.5332 6.16346L41.2895 8.12528C41.9275 8.45849 41.9273 9.37159 41.2892 9.70456L37.5333 11.6644C37.4526 11.7066 37.3867 11.7724 37.3445 11.8532L35.3839 15.6095C35.0508 16.2478 34.1372 16.2475 33.8044 15.609L31.8467 11.8534C31.8045 11.7725 31.7385 11.7065 31.6576 11.6644L27.8996 9.70468C27.2612 9.37177 27.261 8.4583 27.8993 8.12517L31.6578 6.16352C31.7386 6.12135 31.8045 6.05542 31.8466 5.97463L33.8045 2.2205Z"
        fill="#CCCCCC"
      />
      <path
        d="M138.011 38.4386C138.257 37.9669 138.932 37.9668 139.179 38.4383L140.627 41.2129C140.659 41.2725 140.707 41.3212 140.767 41.3523L143.543 42.802C144.014 43.0482 144.014 43.723 143.542 43.969L140.767 45.4173C140.707 45.4484 140.659 45.4971 140.627 45.5568L139.179 48.3325C138.932 48.8042 138.257 48.804 138.011 48.3322L136.565 45.557C136.534 45.4972 136.485 45.4484 136.425 45.4173L133.648 43.9691C133.176 43.7231 133.176 43.0481 133.648 42.8019L136.425 41.3523C136.485 41.3212 136.534 41.2725 136.565 41.2128L138.011 38.4386Z"
        fill="#EFEFF0"
      />
      <path
        d="M7.67789 97.5429C8.03614 96.8559 9.01905 96.8557 9.37767 97.5424L11.4878 101.583C11.5332 101.67 11.604 101.741 11.6908 101.786L15.7334 103.898C16.42 104.256 16.4199 105.239 15.7331 105.597L11.691 107.707C11.6041 107.752 11.5332 107.823 11.4878 107.91L9.37776 111.952C9.01919 112.639 8.036 112.639 7.6778 111.952L5.57086 107.91C5.52549 107.823 5.45448 107.752 5.36744 107.707L1.32292 105.598C0.635858 105.239 0.635679 104.256 1.32261 103.898L5.3676 101.786C5.45454 101.741 5.52547 101.67 5.57082 101.583L7.67789 97.5429Z"
        fill="#EFEFF0"
      />
    </svg>
  )
}

export default OneTimeReportsIcon
